import { graphql } from '@/client/services/api/graphql/gql';

export const getAudienceCountQuery: any = graphql(`
  query AssignmentAudienceCount($audience: [AudienceCountInput!]!) {
    audienceCount(audience: $audience) {
      totalUsers
    }
  }
`);
